import { facilityDashboardResponse, type FacilityDashboardResponse } from "@bitacorapro/api-types";
import { request } from "../client";

// Ingress parse (ADR-0021/D6): catches version-skew between a cached
// dashboard bundle and a newer core-api deploy. Defensive parse on
// both ends — server parses on egress, we parse on ingress.
export async function getFacilityDashboard(): Promise<FacilityDashboardResponse> {
  const json = await request<unknown>("GET", "core", "/facility-dashboard");
  return facilityDashboardResponse.parse(json);
}
